import { Button, Grid, Typography } from '@mui/material'
import React, { useEffect, useState, useRef } from 'react'
import { useLocation, useNavigate } from 'react-router'
import ArrowBackOutlinedIcon from "@mui/icons-material/ArrowBackOutlined";
import i18next from 'i18next';
import Sidebar from './components/Sidebar';
import { trackEvent } from './utils/UtilityFunctions';
import { GlobalWorkerOptions, getDocument } from "pdfjs-dist/webpack";

const UserPrescription = () => {

  // const canvasRef = useRef(null);
  const containerRef = useRef(null);
  const location = useLocation()
  const navigate = useNavigate()
  // const [prescriptionData, setPrescriptionData] = useState({})
  const [prescriptionImg, setPrescriptionImg] = useState('') // your full base64 string
  
  useEffect(() => {
    if(!location?.state?.prescription){
      logEvent('fail', 'prescription not found')
    } else {
      setPrescriptionImg(location.state.prescription)
      logEvent('success')
    }
    if(location?.state?.file_type?.toUpperCase() === 'PDF' && location?.state?.prescription){
      renderPdf()
    }
  }, [])

  // const renderPdf = async () => {
  //   try {
  //     const binary = atob(location?.state?.prescription); // decode base64
  //     const pdf = await getDocument({ data: binary }).promise;
  //     const page = await pdf.getPage(1); // first page
  //     const viewport = page.getViewport({ scale: 1.5 });
  //     const canvas = canvasRef.current;
  //     const context = canvas.getContext("2d");
  //     canvas.height = viewport.height;
  //     canvas.width = viewport.width;
  //     await page.render({ canvasContext: context, viewport }).promise;
  //   } catch (err) {
  //     console.error("PDF render error:", err);
  //   }
  // };

  const renderPdf = async () => {
    try {
      const binary = atob(location?.state?.prescription);
      const pdf = await getDocument({ data: binary }).promise;
      const container = containerRef.current;
      container.innerHTML = ""; // clear before rendering
      for (let pageNum = 1; pageNum <= pdf.numPages; pageNum++) {
        const page = await pdf.getPage(pageNum);
        const viewport = page.getViewport({ scale: 1.5 });
        // create canvas for each page
        const canvas = document.createElement("canvas");
        const context = canvas.getContext("2d");
        canvas.height = viewport.height;
        canvas.width = viewport.width;
        container.appendChild(canvas);
        await page.render({ canvasContext: context, viewport }).promise;
      }
    } catch (err) {
      console.error("PDF render error:", err);
    }
  };
    
  const logEvent = async (status, err) => {
    try {
      await trackEvent('prescription_viewed', status, err ? err : " ", localStorage.getItem('phno'))
    } catch (err) {
      console.log("err", err); 
    }
  }

  return (
    <>
      <div className="photo-container main-section-container prescription-page">
        <Grid
          container
          spacing={0}
          className="d-flex justify-content-start align-items-center"
        >
          <Grid item xs={1} className="">
            <div className="d-flex justify-content-start align-items-center">
              <span
                className="backButtonDiv"
                onClick={() => navigate('/allprescriptions', {state: {user_obj: location.state?.user_obj}})}
              >
                <ArrowBackOutlinedIcon className="arrowBackBtn"></ArrowBackOutlinedIcon>
              </span>
            </div>
          </Grid>
          <Grid
            item
            xs={10}
            className="d-flex justify-content-center align-items-center reportPageHead"
          >
            <Typography variant="h6" className="title ml-0px">
              {i18next.t("Prescription")}
            </Typography>
          </Grid>
          <Grid item xs={1}>
            <Sidebar />
          </Grid>
        </Grid>
        {
          prescriptionImg && location?.state?.file_type?.toUpperCase() === 'IMAGE' ?
            <div className='userprescriptionpage'>
              <img className='mb-20px' src={`data:image/jpeg;base64,${prescriptionImg}`}/> 
            </div>
              :
          prescriptionImg && location?.state?.file_type?.toUpperCase() === 'PDF' ?
            // <canvas className='mt-5px' ref={canvasRef}></canvas>
            <div
              ref={containerRef}
              className='mt-5px pdfPrescriptionContainer'
            ></div>
              :
          prescriptionImg && !location?.state?.file_type ?
            <div className='userprescriptionpage'>
              <img className='mb-20px' src={`data:image/jpeg;base64,${prescriptionImg}`}/> 
            </div>
              : 
            <div className="nodatadiv">
              <Typography className="">
                {i18next.t("No prescription found")}
              </Typography>
            </div>
        }
        {/* {
          (
            location?.state?.user_obj?.prescription_status?.toUpperCase() === 'VALID' || 
            location?.state?.prescription_status?.toUpperCase() === 'VALID'
          ) &&
            <Button className='commonButton mt-10px' onClick={() => navigate('/order', {state: {prescribed_medicine: location.state.prescribed_medicine, user_obj: location?.state?.user_obj}})}>
              {i18next.t('Order now')}
            </Button>
        } */}
      </div>
    </> 
  )
}

export default UserPrescription